export default __webpack_public_path__ + "static/media/ObjectSans-Regular.8e3ca8a2.otf";